module.exports = __webpack_public_path__ + "img/lt-icone-pin-violet.2b07235a.svg";